<template>
  <div class="page-column">
    <Header />
    <div class="content">
      <top></top>
      <center-tab></center-tab>
      <bottom></bottom>
    </div>
    <Footer />
    <BackTop />
  </div>
</template>
<script>
import Header from '../layout/Header.vue'
import Footer from '../layout/Footer.vue'
import Top from './components/Top'
import CenterTab from './components/CenterTab'
import Bottom from './components/Bottom'
import BackTop from '@comm/components/public/BackTop'
export default {
  components: {
    Header,
    Footer,
    Top,
    CenterTab,
    Bottom,
    BackTop,
  },
  data() {
    return {
      programId: this.$route.query.programId,
    }
  },
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  .content {
    position: relative;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/Home.vue